"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8972],{

/***/ 8972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var pwa_mmt_ui_header_ssr_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1782);
/* harmony import */ var pwa_mmt_ui_header_ssr_header__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pwa_mmt_ui_header_ssr_header__WEBPACK_IMPORTED_MODULE_2__);



var ClientHeader = function(props) {
    var data = props.data, localeSettings = props.localeSettings;
    var ref = data || {}, globalConfig = ref.globalConfig, multiLingualData = ref.multiLingualData;
    var currencyChangeHandler = function(currency) {
        if ( true && typeof URL === "function") {
            var currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("_uCurrency", currency);
            window.location.href = currentUrl.toString();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pwa_mmt_ui_header_ssr_header__WEBPACK_IMPORTED_MODULE_2__.Header, {
        globalConfig: globalConfig || {},
        hideExtraHeaderIcons: true,
        multiLingualData: multiLingualData || {},
        showCurrencySwitcher: false,
        localeSettings: localeSettings,
        onCurrencyChange: currencyChangeHandler
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ClientHeader);


/***/ })

}]);